import React from 'react';
import ReactDOM from 'react-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import './ContactModal.css';

const ContactModal = ({ isOpen, onClose }) => {
  if (!isOpen) {
    return null;
  }

  const handleFormSubmit = (e) => {
    e.preventDefault();
    // For now, it does nothing as requested.
    console.log("Form submission intercepted. No action taken.");
    onClose(); // Close the modal on submission for a better user experience.
  };

  const handleOverlayClick = (e) => {
    // Close the modal only if the overlay itself is clicked
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return ReactDOM.createPortal(
    <div className="ULTHOME-contact-modal-overlay" onClick={handleOverlayClick}>
      <div className="ULTHOME-contact-modal-container">
        <button className="ULTHOME-contact-modal-close-btn" onClick={onClose}>
          <FontAwesomeIcon icon={faTimes} />
        </button>
        <div className="ULTHOME-contact-modal-header">
          <h2>Get In Touch</h2>
          <p>We're here to help and answer any question you might have.</p>
        </div>
        <form className="ULTHOME-contact-modal-form" onSubmit={handleFormSubmit}>
          <div className="ULTHOME-contact-form-row">
            <div className="ULTHOME-contact-form-group">
              <label htmlFor="firstName">First Name</label>
              <input type="text" id="firstName" name="firstName" required />
            </div>
            <div className="ULTHOME-contact-form-group">
              <label htmlFor="lastName">Last Name</label>
              <input type="text" id="lastName" name="lastName" required />
            </div>
          </div>
          <div className="ULTHOME-contact-form-group">
            <label htmlFor="email">Email</label>
            <input type="email" id="email" name="email" required />
          </div>
          <div className="ULTHOME-contact-form-group">
            <label htmlFor="inquiry">Inquiry</label>
            <textarea id="inquiry" name="inquiry" rows="4" required></textarea>
          </div>
          <button type="submit" className="ULTHOME-contact-modal-send-btn">
            Send Message
          </button>
        </form>
      </div>
    </div>,
    document.body
  );
};

export default ContactModal; 